import { ReactNode } from 'react'

import { AccentVariant, useStyles } from './styles'

type Props = {
  title: string
  variant: AccentVariant
  date?: string
  statusText?: ReactNode
  createdByName?: string
  institutionName?: string
  tag?: ReactNode
  action?: ReactNode
}

export type SummaryDetailItem = {
  label: string
  value: ReactNode
}

type DetailListProps = {
  variant: AccentVariant
  items: SummaryDetailItem[]
}

export const PersonSummaryDetailList = ({
  variant,
  items
}: DetailListProps) => {
  const { styles } = useStyles({ variant })

  return (
    <div className={styles.detailList}>
      {items.map((item, idx) => (
        <div key={idx} className={styles.detailRow}>
          <span className={styles.detailLabel}>{item.label}</span>
          <span className={styles.detailValue}>{item.value}</span>
        </div>
      ))}
    </div>
  )
}

export const PersonSummaryCard = ({
  title,
  variant,
  date,
  statusText,
  createdByName,
  institutionName,
  tag,
  action
}: Props) => {
  const { styles } = useStyles({ variant })

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        {date && <span className={styles.date}>{date}</span>}
      </div>

      <div className={styles.body}>
        {tag && <div className={styles.statusTag}>{tag}</div>}
        {statusText && <div className={styles.statusText}>{statusText}</div>}
        {action && <div className={styles.actionRow}>{action}</div>}
      </div>

      {(createdByName || institutionName) && (
        <div className={styles.footer}>
          <span className={styles.footerText} title={createdByName}>
            {createdByName ?? ''}
          </span>
          <span className={styles.footerText} title={institutionName}>
            {institutionName ?? ''}
          </span>
        </div>
      )}
    </div>
  )
}
